<script setup lang="ts">
import { Loader2Icon } from 'lucide-vue-next'
</script>
<template>
  <div>
    <Loader2Icon class="h-4 w-4 animate-spin" />
  </div>
</template>
